import { render, staticRenderFns } from "./AdminChatBubble.vue?vue&type=template&id=240fa6b4&scoped=true&"
import script from "./AdminChatBubble.vue?vue&type=script&lang=js&"
export * from "./AdminChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./AdminChatBubble.vue?vue&type=style&index=0&id=240fa6b4&scoped=true&lang=css&"
import style1 from "./AdminChatBubble.vue?vue&type=style&index=1&id=240fa6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240fa6b4",
  null
  
)

export default component.exports